import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.scss'
import axios from 'axios';
import { CUST_ID } from '../../../constants';
import { isAutoServicesTenant } from '../../../utils/tenantBranding';

interface IPROPS {
    setClicked: any;
    clicked: any;
    setIsWorkshopSelectorClicked: any
    setIsCartOpen: any
    setOpenModal: any
    vehicleData: any
    setOpenVehicleModal: any
    setCurrentStep: any
}

const MegaMenu: React.FC<IPROPS> = ({ setCurrentStep, setOpenVehicleModal, vehicleData, setOpenModal, setIsCartOpen, setIsWorkshopSelectorClicked, setClicked, clicked }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const navigate = useNavigate()


    const token = localStorage.getItem("customer-token");
    const fetchingTenant = window.location.hostname.split(".")[0];
    const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
    const apiPort = process.env.REACT_APP_API_PROTOCOL;

    const navArray = [
        { label: "Our Services", highlight: true },
        ...(token ? [{ label: "Vehicle" }] : []),
        { label: "Book Online" },
        { label: "Workshop Locator" },
        { label: "Car Parts" },
        { label: "Join Us" },
        { label: "About Us" },
        { label: "Contact Us" },
    ];

    const tabNavArray = [
        { label: "Our Services", highlight: true },
        ...(token ? [{ label: "Vehicle" }] : []),
        { label: "Book Online" },
        { label: "Workshop Locator" },
        { label: "Car Parts" },
        { label: "Join Us" },

    ];

    const handleNavigation = (item: any) => {

        if (item.label === "Car Parts") {
            if(autoServicesBranding){
                // window.open("https://botgo.io/");
            }else{
                window.open("https://www.eurorepar.com/IN-en/");
            }
        } else {
            if (item.label === "Our Services") {
                navigate("customer/services")
            } else if (item?.label === "Workshop Locator") {
                setIsWorkshopSelectorClicked(true)
                // setIsCartOpen(true)
            }


            else if (item?.label === "Vehicle") {
                navigate("customer/vehicle")


            }

            else if (item?.label === "Book Online") {
                if (!token) {
                    setOpenModal("login");
                    return;
                }

                if (token && vehicleData.length === 0) {
                    setOpenVehicleModal(true)
                    return
                }
                else {
                    navigate('/home')
                    // setIsCartOpen(true)
                    navigate('/vehicle/select')
                    setCurrentStep(1)

                }

            }

            else if (item?.label === "About Us") {
                navigate("customer/about-us")

            }
            else if (item?.label === "Join Us") {
                // setOpenWorkshopModal(true)
                navigate('/join-us')
            }
            else if (item?.label === "Contact Us") {
                navigate('customer/contact-us')

            }
            else if (item?.label === "Contact Us") {
                setOpenModal('contact')

            }
            else {
                // setActiveComponent(false)
            }
        }
        setClicked(item.label);
        setDrawerOpen(false);
    };




    const appointmentHandler = () => {
        navigate('customer/appointments')

    }

    const logoutCustomer = async () => {
        try {
            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/customer/logout/`, {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }

            );
            if (response?.data) {
                localStorage.removeItem("customer-token");
                localStorage.removeItem("login-type");
                localStorage.removeItem(CUST_ID);
                window.location.replace('/home')


            }

        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };

    const logoutHandler = () => {

        logoutCustomer()

    }



    return (
        <div className="home-page-bottom">
            <span className="menu" onClick={() => setDrawerOpen(true)} style={{ fontWeight: "600" }}>
                <span>
                    <i style={{ fontSize: "25px", color: "black" }} className="bi bi-list"></i>
                </span>
                <span style={{ color: "black", fontSize: "17px" }}>
                    Menu
                </span>
            </span>

            <span className="navv">
                {navArray.map((item, i) => {
                    const cleanedLabel = item.label.replace(/Vehicle/gi, '').trim();
                    if (!cleanedLabel) return null; // Skip if label becomes empty
                    return (
                        <span
                            className="nav-text"
                            key={i}
                            onClick={() => handleNavigation(item)}
                            style={{
                                cursor: "pointer",
                                background: clicked === item?.label ? "#FFF3EF" : "",
                                padding: clicked === item?.label ? "10px" : "",
                                borderRadius: "20px",
                                color: clicked === item?.label ? "#E14504" : "#000",
                                fontSize: "17px"

                            }}
                        >
                            {cleanedLabel}
                        </span>
                    );
                })}
            </span>


            <span className="tab-navv">
                {tabNavArray.map((item, i) => {
                    const cleanedLabel = item.label.replace(/Vehicle/gi, '').trim();
                    if (!cleanedLabel) return null; // Skip if label becomes empty
                    return (
                        <span
                            className="nav-text"
                            key={i}
                            onClick={item.label === 'Car Parts' && autoServicesBranding ? undefined : () => handleNavigation(item)}
                            style={{
                                cursor: item.label === 'Car Parts' && autoServicesBranding ? 'not-allowed' : 'pointer',
                                background: clicked === item?.label ? "#FFF3EF" : "",
                                padding: clicked === item?.label ? "10px" : "",
                                borderRadius: "20px",
                                color: clicked === item?.label ? "#E14504" : (item.label === 'Car Parts' && autoServicesBranding ? '#999' : "#000"),
                                fontSize: "17px",
                                opacity: item.label === 'Car Parts' && autoServicesBranding ? 0.6 : 1
                            }}
                        >
                            {cleanedLabel}
                        </span>
                    );
                })}
            </span>


            {/* Side Drawer */}
            {drawerOpen && (
                <div className="drawer-overlay" onClick={() => setDrawerOpen(false)}>
                    <div className="drawer" onClick={(e) => e.stopPropagation()}>
                        <div className="drawer-header">
                            <span style={{ fontFamily: "karbon-medium", fontSize: "20px" }}>Menu</span>
                            <button onClick={() => setDrawerOpen(false)}>X</button>
                        </div>
                        {token &&
                            <div style={{ fontSize: "16px", cursor: "pointer", marginBottom: "15px", fontFamily: "karbon-medium" }} onClick={appointmentHandler}>Appointments</div>
                        }
                        <div className="drawer-links">
                            {navArray.map((item, i) => {
                                const cleanedLabel = item.label.replace(/Car Parts/gi, '').trim();
                                if (!cleanedLabel) return null; // skip rendering if label is empty
                                return (
                                    <div key={i} className="drawer-item" onClick={() => handleNavigation(item)}>
                                        {cleanedLabel}
                                    </div>
                                );
                            })}
                        </div>

                        {token &&
                            <div style={{ fontSize: "16px", cursor: "pointer", marginTop: "15px", fontFamily: "karbon-medium" }} onClick={logoutHandler}>Log out</div>
                        }


                    </div>
                </div>
            )}

            {/* <Modal
                open={openWorkshopModal}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                BackdropProps={{
                    style: {
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                    },
                }}
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }}
                    >
                        <GridCloseIcon />
                    </IconButton>
                    <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mb: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >

                    </Typography>

                    <Box>

                        <WorkshopRequestOnboard closeModal={closeModal} />

                    </Box>
                </Box>
            </Modal> */}
        </div>
    );
};

export default MegaMenu;
